import type { SchemaScope } from './types';

export class SchemaNode {
	/** Generated string scope */
	$scope: string;
	/** Description for the string scope */
	$description: string;

	/**
	 * overriding json stringify
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#tojson_behavior
	 */
	toJSON(): unknown {
		return this.$description;
	}

	constructor(scope: string, description: string) {
		this.$scope = scope;
		this.$description = description;
	}
}

export class PermitNode extends SchemaNode {
	/** access control value for scope */
	private $value = false;

	/** hook function for subscribing to scope changes */
	private $subscriber: Set<(active: boolean, scope: SchemaScope) => void> = new Set();

	constructor(schema: SchemaNode, value = false) {
		super(schema.$scope, schema.$description);
		this.$value = value;
	}

	/** helper for broadcasting changes to subscriber */
	private _broadcast() {
		for (const fn of this.$subscriber.values()) {
			fn(this.$value, { $scope: this.$scope, $description: this.$description });
		}
	}

	toJSON() {
		return {
			scope: this.$scope,
			description: this.$description,
			value: this.$value,
		};
	}

	/** readonly boolean value of true on disabled */
	get $disable() {
		return !this.$value;
	}

	/** boolean value of the scope. will broadcast changes when assigned new value to event listener. */
	get $able() {
		return this.$value;
	}

	/** boolean value of the scope. will broadcast changes when assigned new value to event listener. */
	set $able(value: boolean) {
		this.$value = value;
		this._broadcast();
	}

	/** add listener function to scope that called on value changes */
	$subscribe(fn: (active: boolean, scope: SchemaScope) => void) {
		this.$subscriber.add(fn);
		return () => this.$subscriber.delete(fn);
	}

	/** utility for toggling value. will broadcast changes every call to event listener. */
	$toggle() {
		this.$value = !this.$value;
		this._broadcast();
	}
}